








































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import TopicDetailComment from '@/views/Group/TopPage/NewFeed/TopicDetailComment.vue'
import TopicCommentArea from '@/views/Group/TopPage/NewFeed/TopicCommentArea.vue'
import ModalLikers from '@/components/Modal/ModalLikers.vue'
import ModalFullImageViewer from '@/components/Modal/ModalFullImageViewer.vue'
import {
  Topic,
  TopicLiker,
  EFileFormat,
  TopicAttachFile,
  EUserStatus,
  OptionGroupViewer,
  Member
} from '@/models'
import CheckFileFormat from '@/helpers/CheckFileExtension'
import GroupTopicService from '@/services/GroupTopicService'
import CommonTopicService from '@/services/CommonTopicService'
import GroupService from '@/services/GroupService'
import CommonSharedFolderService from '@/services/CommonSharedFolderService'
import PreviewText from '@/helpers/PreviewText'
import CheckDevice from '@/helpers/CheckDevice'
import {
  getCommonTopicCount,
  triggerFavorite
} from '@/helpers/GetNotificationCount'

import { getModule } from 'vuex-module-decorators'
import CommonTopic from '@/store/modules/CommonTopic'
import store from '@/store'
import { EhumbNailsDisplay } from '@/models/Setting/Enum'
import linkifyHtml from 'linkify-html'
import EmojiPopup from '@/components/EmojiPopup.vue'
import {
  decodeHtml,
  escapeHtml,
  extractContentFromContentEditableOrTiny,
  getEmojiByNativeFunc,
  getInlineEditorImageSrcFromClick,
  handleTranslation,
  hanldeUserStatus
} from '@/helpers/Common'
import { ERR_API_KEY, TRANSLATION_TYPE, MAX_USER_DISPLAY } from '@/constants'
import { readTopicRef } from '@/firebase'
// @ts-ignore
import { Emoji, EmojiIndex } from 'emoji-mart-vue-fast'
// @ts-ignore
import data from 'emoji-mart-vue-fast/data/apple.json'

const CommonTopicModule = getModule(CommonTopic, store)
/**
 * f2-405
 * f2-405a
 * グループ掲示板のトピック詳細
 * グループ掲示板のトピック詳細　いいね・コメント等
 *
 * f2-702
 * f2-702a
 * 共有トピックのトピック詳細
 * 共有トピックのトピック詳細　いいね・コメント等
 */
@Component({
  components: {
    TopicDetailComment,
    TopicCommentArea,
    ModalLikers,
    ModalFullImageViewer,
    EmojiPopup,
    Emoji
  }
})
export default class TopicDetail extends Vue {
  //check that this page is common topic or group
  isCommonTopic = !this.$route.params.groupId
  isDraftTopic: boolean = true
  roleEditTopic: boolean = false
  // NWS-1831 掲示板の削除権限（グループ管理者のみ）。本文の編集権限とは分離する
  roleDeleteTopic: boolean = false
  currentTopic: Topic = new Topic()
  eFileFormat = EFileFormat
  modalMess: string = ''
  modalAction: any = () => {}
  addCommentErrorModalAutoClose: boolean = true
  private delCommentId: number = -1
  maxUserDisplay: number = MAX_USER_DISPLAY
  fullOverviewSrc: string = ''
  noAvatar = require('@/assets/images/avatar-default.png')
  private totalComment: number = 0
  private is404Error: boolean = false
  private skipMarkReadOnLeave: boolean = false
  private confirmLeaveIgnore: boolean = true
  confirmLeave: any = () => {}
  eUserStatus = EUserStatus
  displayThumbnail: boolean =
    this.$store.state.setting.setting.setting_display.display_image_video ===
    EhumbNailsDisplay.DISPLAY_THUMBNAILS
  userListModal: any[] = []
  private from: string = 'Topic Detail'
  errorMess: string = ''
  private readUnsubscribe: any = () => { }
  optionViewer = OptionGroupViewer
  public emojiIndex = new EmojiIndex(data)
  canOpenFullImageModal: boolean = false

  get canShowMoveToBinButton() {
    // NWS-1831 削除はグループ管理者のみ（本文の変更を全員に許可していても開放しない）
    return (
      this.roleDeleteTopic &&
      !this.isCommonTopic &&
      !this.currentTopic.is_in_bin &&
      !this.isDraftTopic
    )
  }

  get canShowEditButton() {
    if (this.currentTopic.is_in_bin) return false
    return this.roleEditTopic
  }

  @Watch('$route.params.topicId')
  async init() {
    this.readUnsubscribe()
    this.is404Error = false
    this.skipMarkReadOnLeave = false
    this.handleReadRealtime()
    const isMarkReadSuccess = await this.handleMarkRead()
    if (!isMarkReadSuccess) return
    this.getCurrentTopic()
    this.handleRoleEditTopic()
    this.resizeIFrameToFitContent()
    this.resizeITableToFitContent()
  }

  handleReadRealtime() {
    let trackingRealtime = true
    this.readUnsubscribe = readTopicRef
      .where('topicId', '==', Number(this.$route.params.topicId))
      .onSnapshot((querySnapshot: any) => {
        if (trackingRealtime) {
          trackingRealtime = false
        } else {
          console.log('📦 Total docs:', querySnapshot.size)
          querySnapshot.docChanges().forEach(async (messageChange: any) => {
            if (
              messageChange.type === 'modified' ||
              messageChange.type === 'added'
            ) {
              const userReadId = messageChange.doc.data().userReadId
              const commentId = messageChange.doc.data().commentId
              if (userReadId !== this.$store.state.userInfo.user.info.id) {
                console.log('data', messageChange.doc.data())
                this.refreshTopicReadUsersOnly()
              }
              if (commentId) {
                this.$bus.$emit('updateComment', commentId)
              }
            }
          })
        }
      })
  }

  created() {
    this.init()
  }

  destroyed() {
    if (this.readUnsubscribe) {
      this.readUnsubscribe()
    }
  }
  beforeRouteLeave(to: any, from: any, next: any) {
    if (!this.skipMarkReadOnLeave) {
      this.handleMarkRead()
    }

    //this case for modal search header
    if (document.querySelectorAll('#modal-search-header').length) {
      next()

      //normal case
    } else if (this.confirmLeaveIgnore) {
      next()
    } else {
      this.confirmLeave = next
      this.$bvModal.show('topic-detail-modal-confirm-leave')
    }
  }

  handleConfirmIgnore(ignore: boolean) {
    this.confirmLeaveIgnore = !ignore
  }

  @Watch('$store.state.userInfo.user.group_role')
  @Watch('$store.state.userInfo.user.common_topic_role')
  @Watch('currentTopic')
  handleRoleEditTopic() {
    if (this.isCommonTopic) {
      this.roleEditTopic = this.$store.state.userInfo.user.common_topic_role
      this.roleDeleteTopic = this.$store.state.userInfo.user.common_topic_role
      return
    }

    if (this.currentTopic.topic_detail.is_multiple_edit) {
      this.roleEditTopic = true //every one can edit topic
    } else {
      this.roleEditTopic = this.$store.state.userInfo.user.group_role.role_edit_topic
    }

    // NWS-1831 削除はグループ管理者のみ。本文の変更(is_multiple_edit)では開放しない
    this.roleDeleteTopic = this.$store.state.userInfo.user.group_role.role_admin
  }

  resizeIFrameToFitContent() {
    const iframes = document.querySelectorAll('iframe')
    iframes.forEach((iFrame: any) => {
      if (iFrame.clientWidth > document.body.clientWidth) {
        iFrame.parentElement.classList.value = 'ratio-16-9'
        iFrame.classList.value = 'position-absolute w-100 h-100 start-0 top-0'
      }
    })
  }

  resizeITableToFitContent() {
    const tables = document.querySelectorAll('table')
    tables.forEach((table: any) => {
      if (table.clientWidth > document.body.clientWidth) {
        table.style.width = '100%'
      }
    })
  }

  async handleMarkRead(handleForMention = false): Promise<boolean> {
    try {
      if (this.isCommonTopic) {
        await CommonTopicService.markAsCommonTopicRead(
          Number(this.$route.params.topicId)
        )
        getCommonTopicCount()
      } else {
        await GroupTopicService.markAsRead(
          this.$route.params.groupId,
          Number(this.$route.params.topicId),
        )
        if (!handleForMention) {
          await GroupTopicService.markAsReadGroupMention(this.$route.params.groupId, Number(this.$route.params.topicId))
        }
      }
      //handle rebind unred count
      CommonTopicModule.SET_RELOAD_UNREAD(true)
      this.skipMarkReadOnLeave = false
      return true
    } catch (err) {
      this.skipMarkReadOnLeave = true
      this.handleTopicNotFound(err)
      return false
    }
  }

  /**
   * Call API get current topic detail
   */
  async getCurrentTopic() {
    if (this.isCommonTopic) {
      return CommonTopicService.getCommonTopicById(this.$route.params.topicId)
        .then(res => {
          if (res.status === 200) {
            this.currentTopic = new Topic(res.data)
            const deliverDate = this.currentTopic.topic_detail.delivery_date
            this.isDraftTopic = this.moment(deliverDate).isAfter(this.moment())
          }
        })
        .catch(err => this.handleTopicNotFound(err))
    } else {
      return GroupTopicService.getTopicById(
        this.$route.params.groupId,
        this.$route.params.topicId
      )
        .then(res => {
          if (res.status === 200) {
            this.currentTopic = new Topic(res.data)
            const deliverDate = this.currentTopic.topic_detail.delivery_date
            this.isDraftTopic = this.moment(deliverDate).isAfter(this.moment())
          }
        })
        .catch(err => this.handleTopicNotFound(err))
    }
  }

  /**
   * Refresh only read-users to avoid overriding local topic UI state
   * (e.g. translated content toggled on client).
   */
  async refreshTopicReadUsersOnly() {
    if (!this.currentTopic?.topic_detail) return

    const request = this.isCommonTopic
      ? CommonTopicService.getCommonTopicById(this.$route.params.topicId)
      : GroupTopicService.getTopicById(
          this.$route.params.groupId,
          this.$route.params.topicId
        )

    return request
      .then(res => {
        if (res.status !== 200) return

        const usersRead = res?.data?.topic_detail?.users_read || []
        this.currentTopic = {
          ...this.currentTopic,
          topic_detail: {
            ...this.currentTopic.topic_detail,
            users_read: usersRead
          }
        }
      })
      .catch(err => this.handleTopicNotFound(err))
  }

  /**
   * Open modal after reactive props (modalMess, modalAction, autoClose, etc.) are flushed to child components.
   */
  private showModalAfterUpdate(modalId: string) {
    this.$nextTick(() => {
      this.$bvModal.show(modalId)
    })
  }

  /**
   * Handle topic not found
   */
  handleTopicNotFound(err: any) {
    if (this.is404Error) return
    if (err.response.status === 404) {
      this.is404Error = true
      if (err.response.data.message === ERR_API_KEY.COMMENT_NOT_FOUND) {
        this.modalMess = this.$t('common.message.comment_not_exist') as string
        this.modalAction = () =>
          (this.$refs as any).topicDetailComment.getAllComments(1)
      } else {
        this.modalMess = this.$t('common.message.topic_not_exist') as string
        this.modalAction = () => this.jumpToNewFeed()
      }
    } else {
      this.modalMess = this.$t('common.message.uncatch_error') as string
      this.modalAction = () => this.jumpToNewFeed()
    }
    this.showModalAfterUpdate('modal-error-topic-detail')
  }

  /**
   * Handle mark favorite for topic
   * Call API mark fovarite
   */
  handleFavor() {
    if (this.isCommonTopic) {
      CommonTopicService.markAsCommonTopicFavorite(this.$route.params.topicId)
        .then(res => {
          if (res.status === 200) {
            this.currentTopic.is_favor = res.data.is_favorite
            triggerFavorite()
          }
        })
        .catch(err => this.handleTopicNotFound(err))
    } else {
      GroupTopicService.markAsFavorite(
        this.$route.params.groupId,
        this.$route.params.topicId
      )
        .then(res => {
          if (res.status === 200) {
            this.currentTopic.is_favor = res.data.is_favorite
            triggerFavorite()
          }
        })
        .catch(err => this.handleTopicNotFound(err))
    }
  }

  addEmoji(emoji: any) {
    this.handleLikeTopic(emoji.native)
  }

  getLikerEmoji() {
    const userLiker = this.currentTopic.liker.find(
      item => item.id === this.$store.state.userInfo.user.profile.user_id
    )
    return userLiker?.emoji_id || ''
  }

  /**
   * Handle like topic
   * Call API like topic
   */
  handleLikeTopic(emojiId?: string) {
    this.$blockui.show()
    const currentEmoji = emojiId || this.getLikerEmoji()
    const payload = {
      emoji_id: currentEmoji
    }
    if (this.isCommonTopic) {
      CommonTopicService.markAsCommonTopicLike(
        this.$route.params.topicId,
        payload
      )
        .then(res => {
          if (res.status === 200) {
            this.handleAfterLikeTopic(currentEmoji, res.data)
          }
        })
        .catch(err => {
          this.handleTopicNotFound(err)
        })
        .finally(() => this.$blockui.hide())
    } else {
      GroupTopicService.markAsLike(
        this.$route.params.groupId,
        this.$route.params.topicId,
        payload
      )
        .then(res => {
          if (res.status === 200) {
            this.handleAfterLikeTopic(currentEmoji, res.data)
          }
        })
        .catch(err => {
          this.handleTopicNotFound(err)
        })
        .finally(() => this.$blockui.hide())
    }
  }

  /**
   * Handle after call API like or dislike topic
   */
  handleAfterLikeTopic(
    emojiId: string,
    data: {
      is_like: boolean
      hide_administrator: boolean
    }
  ) {
    const currentUser = this.$store.state.userInfo.user
    const userId = currentUser.info.id
    const existingIndex = this.currentTopic.liker.findIndex(
      (item: any) => item.id === userId
    )

    this.currentTopic.is_like = data.is_like

    if (data.is_like) {
      if (existingIndex === -1) {
        // user chưa react → thêm mới
        const newLiker = new TopicLiker({
          id: userId,
          liker_name: currentUser.info.name,
          avatar: currentUser.profile.avatar_small,
          emoji_id: emojiId,
          hide_administrator: data.hide_administrator,
          user_active_status: EUserStatus.NORMAL
        })
        this.currentTopic.liker = [newLiker, ...this.currentTopic.liker]
        this.currentTopic.liker_count++
      } else {
        // user đã react → update emoji_id
        this.currentTopic.liker[existingIndex].emoji_id = emojiId
      }
    } else if (existingIndex !== -1) {
      this.currentTopic.liker.splice(existingIndex, 1)
      this.currentTopic.liker_count--
    }
  }

  private getAddCommentErrorHandlers(): Record<string, (err: any) => void> {
    return {
      [ERR_API_KEY.TOPIC_NOT_FOUND]: () => {
        this.modalMess = this.$t('common.message.topic_not_exist') as string
        this.modalAction = () => this.jumpToNewFeed()
        this.showModalAfterUpdate('modal-error-topic-detail')
      },
      [ERR_API_KEY.COMMENT_NOT_FOUND]: () => {
        this.modalMess = this.$t('common.message.comment_not_exist') as string
        ;(this.$refs as any).topicDetailComment.getAllComments(1)
        this.showModalAfterUpdate('modal-error-add-comment')
      },
      [ERR_API_KEY.EXCEED_GROUP_STORAGE_CAPACITY]: () => {
        this.modalMess = this.$t('common.message.group_over_size') as string
        this.showModalAfterUpdate('modal-error-add-comment')
      },
      [ERR_API_KEY.MAX_TOTAL_FILE_SIZE]: (err: any) => {
        this.modalMess = this.$t('common.message.upload_over_size', {
          max: err.response.data.upload_max_file_size
        }) as string
        this.showModalAfterUpdate('modal-error-add-comment')
      },
      [ERR_API_KEY.PERMISSION_DENIED_COMMENT]: (err: any) => {
        const errorMessage = err.response.data.message
        this.modalMess = this.$t(
          `common.message.${errorMessage}`
        ) as string
        this.addCommentErrorModalAutoClose = false
        this.modalAction = () => globalThis.location.reload()
        this.showModalAfterUpdate('modal-error-add-comment')
      },
    }
  }

  catchAddCommentError(err: any) {
    this.addCommentErrorModalAutoClose = true
    this.modalAction = () => {}

    const message = err?.response?.data?.message as string | undefined
    const handler = message
      ? this.getAddCommentErrorHandlers()[message]
      : undefined

    if (handler) {
      handler(err)
      return
    }

    this.modalMess = this.$t('common.message.register_fail') as string
    this.showModalAfterUpdate('modal-error-add-comment')
  }

  setTotalComment(totalComment: number) {
    this.totalComment = totalComment
  }

  /**
   * Open full view for image file
   */
  fullOverview(src: string) {
    this.fullOverviewSrc = src
    this.canOpenFullImageModal = true
  }

  onInlineEditorImageClick(e: MouseEvent) {
    const root = e.currentTarget as HTMLElement
    const src = getInlineEditorImageSrcFromClick(e, root)
    if (!src) return
    e.preventDefault()
    e.stopPropagation()
    this.fullOverview(src)
  }

  /**
   * Handle open confirm modal
   */
  openConfirmModal(commentId?: number) {
    if (commentId !== undefined) {
      this.delCommentId = commentId
      this.modalMess = this.$t('common.message.delete') as string
      this.showModalAfterUpdate('modal-confirm')
      return
    }
    this.delCommentId = -1
    this.modalMess = this.$t('common.message.move_to_bin') as string
    this.showModalAfterUpdate('modal-confirm')
  }

  /**
   * Do when client click YES on confirm modal
   */
  confirmRemoveOrDelCmt() {
    if (this.delCommentId === -1) {
      this.handleMoveToBin()
      return
    }
    this.handleDelCmt()
  }

  /**
   * Call API to move topic to bin
   */
  handleMoveToBin() {
    // NWS-1831 削除はグループ管理者のみ
    if (!this.roleDeleteTopic) return
    this.$blockui.show()
    GroupTopicService.moveTopicsToBin(
      this.$route.params.groupId,
      [this.currentTopic.id],
      this.from
    )
      .then(res => {
        if (res.status === 200) {
          this.modalMess = this.$t('common.message.moved_to_bin') as string
          this.modalAction = () => this.jumpToNewFeed()
          this.showModalAfterUpdate('modal-success')
        }
      })
      .catch(err => {
        if (
          err.response.status === 404 &&
          err.response.data.message === ERR_API_KEY.TOPIC_HAS_BEEN_DELETED
        ) {
          this.modalMess = this.$t('common.message.topic_not_exist') as string
        } else {
          this.modalMess = this.$t('common.message.move_to_bin_fail') as string
        }
        this.modalAction = () => this.jumpToNewFeed()
        this.showModalAfterUpdate('modal-error-topic-detail')
      })
      .finally(() => this.$blockui.hide())
  }

  /**
   * Call API to delete comment
   */
  handleDelCmt() {
    const commentNotExist = this.$t('common.message.comment_not_exist')
    const topicNotExist = this.$t('common.message.topic_not_exist')
    const deleteFail = this.$t('common.message.delete_fail')
    const deleted = this.$t('common.message.deleted')
    this.$blockui.show()
    if (this.isCommonTopic) {
      CommonTopicService.deleteCommonComment(this.delCommentId)
        .then(res => {
          if (res.status === 200) {
            this.modalMess = deleted as string
            this.modalAction = () =>
              // (this.$refs as any).topicDetailComment.getAllComments(1)
              (this.$refs as any).topicDetailComment.filterDeletedComment(
                this.delCommentId
              )
            this.showModalAfterUpdate('modal-success')
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            if (err.response.data.message === ERR_API_KEY.COMMENT_NOT_FOUND) {
              this.modalMess = commentNotExist as string
              this.modalAction = () =>
                (this.$refs as any).topicDetailComment.getAllComments(1)
            } else if (
              err.response.data.message === ERR_API_KEY.TOPIC_NOT_FOUND
            ) {
              this.modalMess = topicNotExist as string
              this.modalAction = () => this.jumpToNewFeed()
            } else {
              this.modalMess = deleteFail as string
              this.modalAction = () =>
                (this.$refs as any).topicDetailComment.getAllComments(1)
            }
          } else {
            this.modalMess = deleteFail as string
            this.modalAction = () =>
              (this.$refs as any).topicDetailComment.getAllComments(1)
          }
          this.showModalAfterUpdate('modal-error-topic-detail')
        })
        .finally(() => this.$blockui.hide())
    } else {
      GroupTopicService.deleteComment(
        this.$route.params.groupId,
        this.delCommentId
      )
        .then(res => {
          if (res.status === 200) {
            this.modalMess = deleted as string
            this.modalAction = () =>
              (this.$refs as any).topicDetailComment.filterDeletedComment(
                this.delCommentId
              )
            this.showModalAfterUpdate('modal-success')
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            if (err.response.data.message === ERR_API_KEY.COMMENT_NOT_FOUND) {
              this.modalMess = commentNotExist as string
              this.modalAction = () =>
                (this.$refs as any).topicDetailComment.getAllComments(1)
            } else if (
              err.response.data.message === ERR_API_KEY.TOPIC_NOT_FOUND
            ) {
              this.modalMess = topicNotExist as string
              this.modalAction = () => this.jumpToNewFeed()
            } else {
              this.modalMess = deleteFail as string
              this.modalAction = () =>
                (this.$refs as any).topicDetailComment.getAllComments(1)
            }
          } else {
            this.modalMess = deleteFail as string
            this.modalAction = () =>
              (this.$refs as any).topicDetailComment.getAllComments(1)
          }
          this.showModalAfterUpdate('modal-error-topic-detail')
        })
        .finally(() => this.$blockui.hide())
    }
  }

  /**
   * Jump to edit topic page
   */
  routeToTopicUpdate() {
    if (this.isCommonTopic) {
      return { name: 'common-topic-new-feed-topic-update' }
    }
    return { name: 'group-new-feed-topic-update' }
  }

  /**
   * Jump to new feed page
   */
  jumpToNewFeed() {
    let router: any
    if (this.$route.params.from) {
      router = this.$route.params.from
    } else if (this.isCommonTopic) {
      router = { name: 'common-topic-new-feed' }
    } else {
      let folder = 'all'
      if (this.$route.params.folder) {
        folder = this.$route.params.folder
      } else if (this.currentTopic.is_in_bin) {
        folder = 'bin'
      }
      router = {
        name: 'group-new-feed',
        query: {
          folder
        }
      }
    }
    this.$router.push(router)
  }

  /**
   * Format date
   */
  formatDate(date: string) {
    const yyyyymmdd = `${this.$t('common.date_format.yyyy_mm_dd')} HH:mm`
    return this.moment(date, yyyyymmdd).format(yyyyymmdd)
  }

  handleLinkifyContent(content: string) {
    return linkifyHtml(content || '', { target: '_blank' })
  }

  /**
   * Call API to get download files stream
   */
  async downloadFile(file: TopicAttachFile) {
    //handle dowload IOS not safari
    if (
      CheckDevice.iOSBrowerName().toLowerCase() !== CheckDevice.safari &&
      CheckDevice.isMobile() &&
      CheckDevice.getMobileOS() === CheckDevice.ios
    ) {
      window.open(file.path)
      return
    }

    //download other
    this.$blockui.show()
    if (this.isCommonTopic) {
      CommonSharedFolderService.downloadCommonFiles([file.id])
        .then(res => {
          if (res.status === 200) {
            this.hanldeDownloadFile(res, file)
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => this.$blockui.hide())
    } else {
      GroupService.downloadFiles(this.$route.params.groupId, [file.id])
        .then(res => {
          if (res.status === 200) {
            this.hanldeDownloadFile(res, file)
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => this.$blockui.hide())
    }
  }

  hanldeDownloadFile(res: any, file: TopicAttachFile) {
    const bytes = new Uint8Array(res.data)
    const blob = new Blob([bytes], { type: '*' })
    let a = document.createElement('a')
    const url = globalThis.URL.createObjectURL(blob)
    a.href = url
    a.setAttribute('target', '_blank')
    a.setAttribute('download', file.name)
    document.body.appendChild(a)
    a.click()
    a.remove()
  }

  handleLongText(text: string, max?: number) {
    return PreviewText.covertToPreviewText(text, max)
  }

  handleUserName(isCreater: boolean) {
    if (this.currentTopic.hide_administrator) {
      return {
        name: this.$t('common.suffix.admin').toString(),
        text: this.$t('common.suffix.admin').toString(),
      }
    }

    const name = isCreater
      ? this.currentTopic.creater_name
      : this.currentTopic.updater_name

    const status = isCreater
      ? this.currentTopic.creater_active_status
      : this.currentTopic.updater_active_status

    let text = hanldeUserStatus(name, status)

    const preview = PreviewText.covertToPreviewText(text)
    return {
      name: text,
      text: preview.text
    }
  }

  handleSettingViewerDisplay() {
    if (!this.currentTopic?.topic_detail) {
      return ''
    }

    if (
      this.currentTopic.topic_detail.option_viewer ===
      OptionGroupViewer.EVERYONE
    ) {
      return this.$t('groups.everyone')
    }

    if (
      this.currentTopic.topic_detail.option_viewer ===
      OptionGroupViewer.AUTHORITY
    ) {
      return this.$t('groups.member_list.role_permission')
    }

    if (
      this.currentTopic.topic_detail.option_viewer ===
      OptionGroupViewer.INDIVIDUAL
    ) {
      return this.$t('groups.individual')
    }
  }

  handleFileNameWithSize(attachFile: TopicAttachFile) {
    if (!attachFile.size) return this.handleLongText(attachFile.name, 40).text
    const bytes = Number(attachFile.size)
    let sizeText = '0 KB'
    if (bytes) {
      if (bytes < 1) {
        sizeText = '1 KB'
      } else {
        const k = 1024
        const sizes = ['KB', 'MB', 'GB', 'TB']
        const i = Math.floor(Math.log(bytes) / Math.log(k))
        sizeText =
          Number.parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
      }
    }
    return this.handleLongText(attachFile.name, 40).text + ` (${sizeText})`
  }

  getFileFormat(extension: string) {
    return CheckFileFormat.getFileFormat(extension)
  }

  getFormatIconClass(extension: string) {
    return CheckFileFormat.getIconClassNameWithFileExtention(extension)
  }

  getUserAvatarSmall(user: any): string {
    return user && user.user_profile && user.user_profile.avatar_small
      ? user.user_profile.avatar_small
      : ''
  }

  openUserListModal(list: Member[]) {
    this.userListModal = list?.map(item => {
      return {
        id: item.user_active_status ? -1 : item.id,
        avatar:
          item.user_active_status === EUserStatus.LEAVE_SYSTEM
            ? ''
            : this.getUserAvatarSmall(item),
        liker_name: item.name,
        user_active_status: item.user_active_status,
        hide_administrator: item.hide_administrator
      }
    })

    this.showModalAfterUpdate('topic-user-list')
  }

  resetTopicDetailTranslation() {
    this.currentTopic = {
      ...this.currentTopic,
      topic_detail: {
        ...this.currentTopic.topic_detail,
        isTranslated: false
      }
    }
  }

  async onTranslateTopicTitleAndContent() {
    const { topic_detail } = this.currentTopic

    if (topic_detail.isTranslated) {
      this.resetTopicDetailTranslation()
      return
    }

    const hasTitleTranslation = !!topic_detail.title_translation
    const hasContentTranslation = !!topic_detail.content_translation

    if (hasTitleTranslation && hasContentTranslation) {
      this.currentTopic = {
        ...this.currentTopic,
        topic_detail: {
          ...topic_detail,
          isTranslated: true
        }
      }
      return
    }

    const q: string[] = []
    const rawTitle = topic_detail.topic_title?.trim()
    const needTranslateTitle = !hasTitleTranslation && rawTitle

    if (needTranslateTitle) {
      q.push(rawTitle)
    }

    const contentHtml = this.handleLinkifyContent(topic_detail.content)
    const needTranslateMemo = !hasContentTranslation && contentHtml

    const { doc, textNodes } = extractContentFromContentEditableOrTiny(
      contentHtml
    )

    if (needTranslateMemo) {
      q.push(...textNodes.map(t => t.originalText))
    }

    if (!q.length) {
      this.currentTopic = {
        ...this.currentTopic,
        topic_detail: {
          ...topic_detail,
          isTranslated: true
        }
      }
      return
    }

    await handleTranslation({
      modalId: 'topic-detail-translation-error-modal',
      q,
      onSuccess: async (res: any) => {
        const translations =
          res?.map((t: any) => decodeHtml(t.translatedText)) || []

        let titleTranslation = ''
        if (!topic_detail.title_translation) {
          titleTranslation = translations.shift()
          this.currentTopic.topic_detail.title_translation = titleTranslation
        }

        let contentTranslation = ''
        if (!topic_detail.content_translation) {
          for (const item of textNodes) {
            const translated = translations.shift() || ''
            const indentHtml = item.indent.replaceAll(' ', '&nbsp;')

            const parent = item.node.parentNode as HTMLElement
            const span = document.createElement('span')
            span.innerHTML = indentHtml + escapeHtml(translated)

            parent.replaceChild(span, item.node)
          }

          contentTranslation = doc.body.innerHTML
          this.currentTopic.topic_detail.content_translation = contentTranslation
        }

        this.currentTopic.topic_detail.isTranslated = true

        return {
          target_id: Number(this.$route.params.topicId),
          type: TRANSLATION_TYPE.TOPIC,
          content_translation: contentTranslation,
          title_translation: titleTranslation
        }
      },
      onError: (message: string) => {
        this.errorMess = message
      },
    })
  }

  getEmojiByNative(nativeChar: string) {
    return getEmojiByNativeFunc(nativeChar, this.emojiIndex)
  }

  getDisplayTopicLikers() {
    return (this.currentTopic?.liker || []).slice(0, this.maxUserDisplay)
  }

  getTopicLikerRemainCount() {
    const total = (this.currentTopic?.liker || []).length
    return Math.max(total - this.maxUserDisplay, 0)
  }

}
